import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import HowToRegIcon from '@mui/icons-material/HowToReg';
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';

import { RequestButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box';
import { postData } from "../func/api";
import { useAuth } from "../contexts/AuthContext"; 
import { BaseDialog } from "./base_dialog";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {validationCheckCheckResult, validationCheckCheckSummary, validationCheckEarthquake} from '../func/validation_check'


export default function RequestApprovalDialog({ earthquake, checkResult, checkSummary, type, createComplete, facilityDams }) {
    const [open, setOpen] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const handleClickOpen = () => {
        setOpen(true);
        setErrorMessage("");
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleSendApproval = async () => {
      try {
            const payload = {
                earthquake: earthquake,
                check_result: checkResult,
                user_uuid: currentUser.id
            };
            // 第一報
            if (type === "initial") {
                // エラーチェック
                const messageEarthquake = validationCheckEarthquake(earthquake)
                if (messageEarthquake) {
                    setAlertMessage(messageEarthquake);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }

                // エラーチェック
                const messageCheckResult = validationCheckCheckResult(checkResult, facilityDams)
                if (messageCheckResult) {
                    setAlertMessage(messageCheckResult);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }

                await postData("api/post_first_approval_request", payload);
                window.location.href = `/first_report/${earthquake.uuid}`;
            // 1次点検
            }else if (type === "primary"){
                // エラーチェック
                const message = validationCheckCheckSummary(checkSummary)
                if (message) {
                    setAlertMessage(message);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }
                // エラーが無ければPOST
                await postData("api/post_primary_approval_request", payload);
                window.location.href = `/primary_inspection/${earthquake.uuid}`;
            // 2次点検
            }else{
                // エラーチェック
                const message = validationCheckCheckSummary(checkSummary)
                if (message) {
                    setAlertMessage(message);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }
                // エラーが無ければPOST
                await postData("api/post_secondary_approval_request", payload);
                window.location.href = `/secondary_inspection/${earthquake.uuid}`;
            }
        } catch (error) {
            console.error("承認依頼の送信に失敗しました。：", error);
            
            setAlertMessage("承認依頼の送信に失敗しました。");
            setAlertSeverity("error");
        } finally {
            // Alert を表示
            setAlertMessage("承認依頼を実施しました。")
            setAlertOpen(true);
        }
    };

    return (
        <>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
            <BoxSpaceCenter>
                <RequestButton startIcon={<HowToRegIcon />} onClick={handleClickOpen} disabled={!createComplete} variant="contained">
                    承認依頼
                </RequestButton>
                <BaseDialog
                    open={open}
                    onClose={handleClose}
                    title="承認依頼"
                    message={"報告書の記載内容について承認依頼を行います。\nよろしいですか？"}
                    onConfirm={handleSendApproval}
                    confirmText='送信'
                    cancelText='キャンセル'
                />
            </BoxSpaceCenter>
            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // 右上に表示
            >
                <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
